// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".templ{margin-bottom:-20px}.searchMenu{width:500px}.dropSearchMenu{margin-top:-35px;margin-left:15px}", ""]);
// Exports
module.exports = exports;
